module.exports = "/fonts/Flaticon.eot?35d544eaaa4cf3c6355866280d53ba73";